// extracted by css-extract-rspack-plugin
export default {"Box":"suggested-item-option-module__Box__K5pKLQq","Box_1":"suggested-item-option-module__Box_1__jeXCb4Q","Text":"suggested-item-option-module__Text___tNWYDT"};